import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Category } from '../interfaces/category.interface';
import { Menu } from '../interfaces/configuration.interface';
import { Province } from '../interfaces/province.interface';
import { environment } from '@/environments/environment';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

// import { Cart, CartItem } from '../interface/cart.interface';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public authEvent: EventEmitter<boolean> = new EventEmitter();
  public productEvent: EventEmitter<boolean> = new EventEmitter();
  public selectType: EventEmitter<string> = new EventEmitter();

  private cart = new BehaviorSubject<any>(null);
  public getCart = this.cart.asObservable();
  setCart(cart: any) {
    this.cart.next(cart);
  }

  private provinces = new BehaviorSubject<Province[]>([]);
  public getProvinces = this.provinces.asObservable();
  setProvinces(provinces: Province[]) {
    this.provinces.next(provinces);
  }

  private cartItem = new BehaviorSubject<any>(null);
  public getCartItem = this.cartItem.asObservable();
  setCartItem(cartItem: any) {
    this.cartItem.next(cartItem);
  }

  private categories = new BehaviorSubject<Category[]>([]);
  public getCategories = this.categories.asObservable();
  setCategories(categories: Category[]) {
    this.categories.next(categories);
  }

  private category = new BehaviorSubject<Category>(new Category());
  public getCategory = this.category.asObservable();
  setCategory(category: Category) {
    this.category.next(category!);
  }

  private configuration = new BehaviorSubject<any>(null);
  public getConfiguration = this.configuration.asObservable();
  setMenu(config: any) {
    this.configuration.next(config);
  }

  private sidebar = new BehaviorSubject<Menu[]>([]);
  public getSidebar = this.sidebar.asObservable();
  setSidebar(sidebar: Menu[]) {
    this.sidebar.next(sidebar);
  }

  public appInfo: any;

  constructor() {
    this.appInfo = this.getBrowserInfo();
  }

  getPager(totalItems: number, currentPage: number, pageSize: number, paginateRange: number) {

    // calculate total pages
    let totalPages = Number(Math.ceil(Number(totalItems) / Number(pageSize)));

    // Paginate Range


    // ensure current page isn't out of range
    if (Number(currentPage) < 1) {
        currentPage = 1;
    } else if (Number(currentPage) > Number(totalPages)) {
        currentPage = Number(totalPages);
    }

    let startPage: number, endPage: number;
    if (Number(totalPages) <= Number(paginateRange)) {
        // Less than or equal to the paginateRange
        startPage = 1;
        endPage = Number(totalPages);
    } else if (Number(currentPage) <= Number(Math.floor(Number(paginateRange) / 2))) {
        // Near the beginning
        startPage = 1;
        endPage = Number(paginateRange);
    } else if (Number(currentPage) >= Number(totalPages) - Number(Math.floor(Number(paginateRange) / 2))) {
        // Near the end
        startPage = Number(totalPages) - Number(paginateRange) + 1;
        endPage = Number(totalPages);
    } else {
        // In the middle
        startPage = Number(currentPage) - Number(Math.floor(Number(paginateRange) / 2));
        endPage = Number(currentPage) + Number(Math.floor(Number(paginateRange) / 2));
    }

    // calculate start and end item indexes
    let startIndex = (Number(currentPage) - 1) * Number(pageSize);
    let endIndex = Math.min(Number(startIndex) + Number(pageSize) - 1, Number(totalItems) - 1);


    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array((Number(endPage) + 1) - Number(startPage)).keys()).map(i => Number(startPage) + Number(i));

    // return object with all pager properties required by the view
    return {
        totalItems: totalItems,
        currentPage: currentPage,
        pageSize: pageSize,
        totalPages: totalPages,
        startPage: startPage,
        endPage: endPage,
        startIndex: startIndex,
        endIndex: endIndex,
        pages: pages
    };
  }

  // Lấy text thuần từ HTML của CKEditor (bỏ ảnh, caption ảnh, media...), cắt tối đa maxLength ký tự
  extractPlainText(html: string, maxLength: number): string {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.body.querySelectorAll('img, figure.image, picture, svg, video, audio, iframe, script, style')
      .forEach(el => el.remove());
    // Chèn khoảng trắng sau các thẻ block để chữ giữa các đoạn không bị dính vào nhau
    doc.body.querySelectorAll('p, div, br, li, h1, h2, h3, h4, h5, h6, td, th, blockquote, figcaption')
      .forEach(el => el.after(' '));
    const text = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    return text.slice(0, maxLength).trim();
  }

  slugify(str: string): string {
    const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
    const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return str.toString().toLowerCase()
      .replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a')
      .replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e')
      .replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i')
      .replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o')
      .replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u')
      .replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y')
      .replace(/đ/gi, 'd')
      .replace(/\s+/g, '-')
      .replace(p, c => b.charAt(a.indexOf(c)))
      .replace(/&/g, '-and-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '')
  }

  /**
   * Parse JWT
   * @param token
   * @returns json object
  */
  parseJwt (token: string) {
    try {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }
    catch {
      return null;
    }
  }

  getBrowserInfo() {
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "OPR" or after "Version"
    if ((verOffset = nAgt.indexOf("OPR")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
            fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MS Edge, the true version is after "Edg" in userAgent
    else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
        browserName = "Microsoft Edge";
        fullVersion = nAgt.substring(verOffset + 4);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
            fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    return {
      from: `${environment.from}`,
      platform: `${browserName}`,
      source: `${environment.source}`,
      version: `${fullVersion}`
    };
  }

  convertNgbDateToDate(date: NgbDateStruct): string | undefined {
    if (!date || date.year === 0 || date.month === 0 || date.day === 0) {
      return undefined;
    }
    return `${date.year}-${this.formatSingleDigitToDoubleDigit(date.month)}-${this.formatSingleDigitToDoubleDigit(date.day)}`;
  }
  formatSingleDigitToDoubleDigit(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
}
